import { combineReducers } from 'redux';
import meeting from './meeting';
import meetings from './meetings';
import greyhound from './greyhound';
import race from './race';
import fastResults from './fastResults';

export default combineReducers({
  meeting,
  meetings,
  greyhound,
  race,
  fastResults
});



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/reducers/reducer.js